import {useEffect, useState} from 'react';

const TOOLTIP_SHOW_DELAY_MS = 1500;
const TOOLTIP_VISIBLE_DURATION_MS = 5000;

export function useShowMoreOffersTooltip(hiddenOffersCount: number) {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    useEffect(() => {
        if (hiddenOffersCount <= 0) {
            setIsTooltipOpen(false);
            return;
        }

        const showTimer = setTimeout(() => {
            setIsTooltipOpen(true);
        }, TOOLTIP_SHOW_DELAY_MS);

        const hideTimer = setTimeout(() => {
            setIsTooltipOpen(false);
        }, TOOLTIP_SHOW_DELAY_MS + TOOLTIP_VISIBLE_DURATION_MS);

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
        };
    }, [hiddenOffersCount]);

    return isTooltipOpen;
}
